import React from 'react';
import PropTypes from 'prop-types';
import { taskActions } from 'actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

const DataRow = ({ ...props }) => {
  DataRow.propTypes = {
    task: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    referrals: PropTypes.array,
    shouldRedirect: PropTypes.bool,
    name: PropTypes.string,
    opportunityId: PropTypes.array,
    contactId: PropTypes.string,
    setActiveOpportunity: PropTypes.func
  };

  const { eventId, name, contactId, opportunityId, description, startTime, contactName } = props.task;

  const redirectToTaskDetails = async () => {
    const referral = _.find(props.referrals, { contactKey: contactId }, []);
    const opportunity = _.find(_.get(referral, 'opportunities', {}), { opportunityKey: opportunityId });

    if (name === 'Weekly Status Update') {
      await props.setActiveOpportunity(opportunity);
      props.history.push(`/statusupdates/${contactId}/${opportunityId}`);
    } else {
      props.history.push(`/taskdetails/${eventId}`);
    }
  };

  const shouldRedirect = _.get(props, 'shouldRedirect', true);
  const showTaskStatus = _.get(props, 'showTaskStatus', true);

  return (
    <div className={'task-row'} onClick={() => shouldRedirect && redirectToTaskDetails()}>
      <div className='icon-container'>
        <i className='icon-tasks' />
      </div>
      <div className='task-details'>
        <h3>{moment(startTime).format('hh:mm A')} {name.toLowerCase() === 'other' ? description : name}</h3>
        <p>{contactName}</p>
      </div>
      {showTaskStatus && taskActions.buildTaskStatus(props.task)}
    </div>
  );
};

export default connect((state) => { return {}; })(withRouter(DataRow));
